module.exports = __webpack_public_path__ + "img/img-54.a8c873d2.png";